import React, { Component } from 'react';
import { connect } from 'react-redux';

import LocationFetch, { getGeocodedLocation } from './LocationFetch';
import { setGeoLocation } from '../../../actions/search-actions';

export default (ChildComponent) => {
    class RequestLocation extends Component {
        constructor(props) {
            super(props);
            this.innerRef = null;
            this.childRef = null;
            this.getInnerRef = this.getInnerRef.bind(this);
            this.fetchCurrentLocation = this.fetchCurrentLocation.bind(this);
            this.onLocationFetchSuccess = this.onLocationFetchSuccess.bind(this);
            this.onLocationFetchFailure = this.onLocationFetchFailure.bind(this);
            this.state = {
                locationRecieved: false,
                onLocationRecieved: null,
            };
        }

        getInnerRef(ref) {
            this.innerRef = ref;
        }

        fetchCurrentLocation(onLocationRecieved) {
            if (this.innerRef) {
                this.setState({
                    locationRecieved: false,
                    onLocationRecieved,
                });
                this.innerRef.getLocation();
            } else {
                // Fetch user location
                this.onLocationFetchFailure();
            }
        }

        // eslint-disable-next-line react/sort-comp
        async onLocationFetchSuccess(position) {
            if (!this.state.locationRecieved) {
                this.setState({
                    locationRecieved: true,
                });
                const locationObject = await getGeocodedLocation(position.coords.latitude, position.coords.longitude);
                if (this.state.onLocationRecieved) {
                    this.state.onLocationRecieved(locationObject);
                }
                this.props.setGeoLocation(locationObject);
            }
        }

        async onLocationFetchFailure() {
            if (!this.state.locationRecieved) {
                this.setState({
                    locationRecieved: true,
                });
                // send user location
                if (this.props.auth && this.props.auth.user && this.props.auth.user.location && this.props.auth.user.location.display && this.props.auth.user.location.latLng && this.props.auth.user.location.latLng[0] && this.props.auth.user.location.latLng[1]) {
                    const locationObject = {
                        location: this.props.auth.user.location.display,
                        lat: this.props.auth.user.location.latLng[0],
                        lng: this.props.auth.user.location.latLng[1],
                    };
                    if (this.state.onLocationRecieved) {
                        this.state.onLocationRecieved(locationObject);
                    }
                    this.props.setGeoLocation(locationObject);
                } else {
                    console.log('No User Location to fetch');
                }
            }
        }

        render() {
            return (
                <React.Fragment>
                    <ChildComponent
                        {...this.props}
                        fetchCurrentLocation={this.fetchCurrentLocation}
                    />
                    <LocationFetch
                        auth={this.props.auth}
                        search={this.props.search}
                        ref={this.getInnerRef}
                        onError={this.onLocationFetchFailure}
                        onSuccess={this.onLocationFetchSuccess}
                        setLocationInReducer={this.props.setGeoLocation}
                    />
                </React.Fragment>
            );
        }
    }

    const mapDispatchToProps = {
        setGeoLocation,
    };

    function mapStateToProps({ auth, search }) {
        return { auth, search };
    }

    return connect(mapStateToProps, mapDispatchToProps)(RequestLocation);
};
